export { default } from "./getActiveElement.mjs";